import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {unsafeHTML} from 'lit-html/directives/unsafe-html.js';
import {msg} from '@lit/localize';

import store from '../../store';

@customElement('family-tendertext')
export class FamilyTenderText extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				margin: 0;
			}

			.familyTenderText p {
				font: var(--font-specsheet-small-text);
			}
			.familyTenderText hr {
				color: transparent;
				border-bottom: 1px solid #c6c6c6;
			}

			@media print {
				:host {
					width: 100%;
					margin: 0;
				}

				.familyTenderText p {
					font: var(--font-specsheet-print-small-text);
					margin-top: 0px;
					margin-bottom: 0px;
				}

			}

		`]
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		if (state.specsheet.data.specsheets && state.status?.productFamily) {
			this.kirbySpecsheets = state.specsheet.data.specsheets;
			this.family = state.status.productFamily;
			this.kirbySpecsheet = this.kirbySpecsheets.find(specsheet => specsheet.id === this.family);
		}
	}

	render() {
		if (!this.kirbySpecsheet) return html``;

		return html`
        <div>
			<section class="familyTenderText">
				<h3>${msg('Family Tender Text')}</h3>
				<p>${unsafeHTML(this.kirbySpecsheet.family_tendertext)}</p>
			</section>
		</div>
		`;
	}
}
